import { EventPrivateSelect } from "@pages/makeEvent/steps-components/eventMode-component/types.ts";
import { EventTypeSelection } from '@pages/makeEvent/steps-components/eventType-component/types.ts'
import { AddressLocation } from "@app/data/location/schema";

export type UiRegion = {
  value?: AddressLocation
  label: string
}

export type UiAddress = {
  label: string
  value: AddressLocation
}

export interface EventDialogState {
  showEvent: boolean,
  region?: UiRegion,
  address?: UiAddress
  eventModePrivate?: EventPrivateSelect,
  eventType?: EventTypeSelection
}

export const defaultEventDialogState = (): EventDialogState => ({
  showEvent: false,
  })